<script setup lang="ts">
import { mdiWindowClose } from '@mdi/js'
import BaseButton from '@/shared/components/button/BaseButton.vue'
import SvgIcon from '@/shared/components/icon/SvgIcon.vue'

interface Props {
  title: string
  loading?: boolean
}

interface Emits {
  (e: 'close'): void
}

defineProps<Props>()
defineEmits<Emits>()
</script>

<template>
  <div class="relative py-4 mx-4">
    <div class="inline-flex text-nowrap items-center absolute top-0 inset-0">
      <div class="font-medium text-lg text-gray-700 pr-2">{{ title }}</div>
      <div class="border-t border-gray-500 w-full"></div>
    </div>
    <div class="flex items-center justify-end relative">
      <slot></slot>
      <BaseButton
        :title="$t('common.close')"
        class="peer bg-white border border-gray-500 text-sm p-2 enabled:hover:bg-gray-100"
        @click="$emit('close')"
      >
        <SvgIcon :path="mdiWindowClose" class="w-5 h-5" />
      </BaseButton>
    </div>
  </div>
</template>
